import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getReplenishmentBaseProducts(pageIndexDetails) {
  return fetchQuery("GetReplenishmentBaseProducts", pageIndexDetails);
}
